import { useState, useEffect } from 'react'
import { usePages } from './pages'
import { useLoading } from '@orbital/games-frontend-library'

export const useCustomLoader = (handleAbove: any, id: string, stateRound: number) => {
  const enableLoading = window.location.hostname !== 'localhost'
  const pages = usePages(enableLoading)
  const [isLoaded, setisLoaded] = useState(false)
  const [arePagesLoaded, duration] = useLoading(handleAbove, pages)


  const [animationIsOver, setanimationIsOver] = useState(false)


  useEffect(() => {
    switch (stateRound) {
      case 0:
        setanimationIsOver(true)
        break;
      case 99:
        setanimationIsOver(false)
        break;
      case 4:
      case 14:
      case 15:
        setTimeout(() => {
          setanimationIsOver(true)
        }, 1500);
        break;

      default:
        break;
    }
  }, [stateRound])

  useEffect(() => {
    setisLoaded(arePagesLoaded && !!id && animationIsOver)
  }, [arePagesLoaded, id, animationIsOver, setisLoaded])


  const showLoader = !isLoaded && enableLoading

  return [showLoader, duration] as const
}
